import React from 'react';

const GraphNode = ({ node, isSelected, onClick }) => {
    const classNames = `graph-node ${node.type} ${isSelected ? 'selected' : ''}`;
    return (
        <div 
            className={classNames} 
            style={{ top: `${node.y}px`, left: `${node.x}px` }}
            onClick={() => onClick(node)}
        >
            {node.icon && <div className="mb-1">{node.icon}</div>}
            <div>{node.label}</div>
        </div>
    );
};

export default GraphNode;